export const MOBILE_APP_UNSUPPORTED_BANNER_TITLE = 'Подборки_можно_посмотреть_в_приложении_106';
export const downLoadUrl = 'https://cian.onelink.me/2426377992/5a271098';
